<template>
<router-link class="is-block category-tile promoted" :to="item.link">
    <div :class="['category-tile__bg', {'black-out': centred}]" :style="'background-image: url(' + item.bg.url + ');'"></div>
    <div :class="['category-tile__inner', {'has-text-centered': centred}]">
        <p v-if="item.subtitle && centred" class="subtitle is-6">{{item.subtitle}}</p>
        <h2 class="title is-3">{{item.title}}</h2>
        <p v-if="item.subtitle && !centred" class="subtitle is-6">{{item.subtitle}}</p>
    </div>
</router-link>
</template>

<script>
export default {
    name    :   'PromotedCategoryTile',
    props   :   ['item', 'centred']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/PromotedCategoryTile.vue